import React from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "src/Router";
import { UserStore } from "src/contexts/UserContext";

import "antd/dist/antd.css";
import "moment/locale/mn";
import { ConfigProvider } from "antd";
import mnMN from "antd/lib/locale/mn_MN";

const App = () => {
  return (
    <UserStore>
      <BrowserRouter>
        <ConfigProvider locale={mnMN}>
          <Router />
        </ConfigProvider>
      </BrowserRouter>
    </UserStore>
  );
};
export default App;
